<div class="dialog-container">
  <app-mat-spinner-overlay
    [overlay]="true"
    *ngIf="loading"
  ></app-mat-spinner-overlay>

  <div class="dialog-header">
    <h2 mat-dialog-title>Recusar {{ labelAcordo }}</h2>
    <button
      mat-icon-button
      [mat-dialog-close]="false"
      class="close-button"
      matTooltip="Fechar diálogo"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-content">
    <div class="sumarizacao-acordos" *ngIf="acordosSelecionados?.length">
      <h4>Você está prestes a recusar o(s) seguinte(s) acordo(s):</h4>
      <ul>
        <li *ngFor="let acordo of acordosSelecionados">
          Acordo Nº: {{ codigoAcordo(acordo) }} Frota:
          {{ acordo.razaoSocialFrota }}
        </li>
      </ul>
    </div>
    <form [formGroup]="formRejeicao" class="mt-3">
      <mat-form-field appearance="outline" class="motivo-field w-100">
        <mat-label>Motivo da rejeição</mat-label>
        <textarea matInput formControlName="motivo" rows="4"></textarea>
        <mat-error *ngIf="formRejeicao.get('motivo')?.hasError('required')">
          O motivo do cancelamento é obrigatório.
        </mat-error>
      </mat-form-field>
    </form>
    <p *ngIf="(acordosSelecionados || []).length > 1" class="aviso-multiplos">
      O mesmo motivo será aplicado para todos os
      {{ acordosSelecionados.length }} acordos selecionados.
    </p>
    <div class="row">
      <div class="col-12 text-end">
        <button mat-button class="btn-acao" (click)="onCancelar()">
          Voltar
        </button>
        <button
          mat-raised-button
          class="btn-acao btn-confirmar"
          [disabled]="
            !formRejeicao.valid || !(acordosSelecionados || []).length
          "
          (click)="onConfirmar()"
        >
          Recusar {{ labelAcordo }}
        </button>
      </div>
    </div>
  </div>
</div>
